import { PanelBarTemplate } from "../../../../../shared/expandable-panelbar/expandable-panelbar.component";
import { PartApprovalPanelbar } from "./part-approval-panelbar";
import { RequestDetailService } from "../detail.service";
import { Injector } from "@angular/core";
import { LocationApprovalPanelbar } from "./location-approval-panelbar";

export class PartApprovalMatrix extends PanelBarTemplate {

    private readonly partApprovalPanelbar: PartApprovalPanelbar = new PartApprovalPanelbar(this.injector);
    private readonly locationApprovalPanelbar: LocationApprovalPanelbar = new LocationApprovalPanelbar(this.injector);

    private readonly detailService: RequestDetailService;

    constructor(
        private readonly injector: Injector
    ) {
        super();
        this.detailService = injector.get(RequestDetailService);

        this.title = 'Part Approval Matrix';
        this.iconClass = 'fa-wrench';
        this.canRefresh = false;
        this.expanded = true;
        this.id = this.title;
        this.detailService.partApprovalData
            .subscribe(data => {
                this.updatePartApprovalPanelbar(data);
                this.updateLocationApprovalPanelbar(data);
            });
    }


    /**
     * 
     */
    refresh = () => this.detailService.refreshPartApprovalMatrix();


    /**
     * 
     * @param dataItem 
     */
    private updatePartApprovalPanelbar(dataItem: any) {
        this.loading.next(true);
        if (!dataItem || typeof (dataItem) === typeof (true)) {
            this.loading.next(dataItem);
            return;
        }

        this.partApprovalPanelbar.setPartApprovalData(dataItem);
        if (!this.panelBars.some(x => x.title === this.partApprovalPanelbar.title) &&
            this.partApprovalPanelbar.panelBars.length > 0) {
            this.addPanelBar(this.partApprovalPanelbar);
        }
        this.loading.next(false);
    }


    /**
     * 
     * @param dataItem 
     */
    private updateLocationApprovalPanelbar(dataItem: any) {
        if (!dataItem) {
            this.loading.next(false);
            return false;
        }
        this.locationApprovalPanelbar.setLocationApprovalData(dataItem);
        if (!this.panelBars.some(x => x.title === this.locationApprovalPanelbar.title) &&
            (this.locationApprovalPanelbar.panelBars.length > 0 || this.locationApprovalPanelbar.forms.length > 0)) {
            this.addPanelBar(this.locationApprovalPanelbar);
        }
        return true;
    }

}

